// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","main-color":"var(--main-color)","section_container":"_1QdzgSB","flex_contents":"o56HHfs"};